import { jsx as a } from "react/jsx-runtime";
import { useState as l, useCallback as i, useEffect as u, useMemo as C } from "react";
import { SCALE_FACTOR as f, DEFAULT_SCALE_FACTOR as E } from "../../../config/globalConstants.js";
import { ScaleContext as d } from "../ScaleContext.js";
const F = ({
  children: c,
  initialScaleFactor: s = f,
  saveScaleFactor: e
}) => {
  const [o, n] = l(s), r = i(
    (t) => {
      e?.(t), n(t);
    },
    [e]
  );
  u(() => {
    document.documentElement.classList.toggle("scalingEnabled", o !== E);
  }, [o]);
  const m = C(() => ({ scaleFactor: o, onScaleChange: r }), [o, r]);
  return /* @__PURE__ */ a(d.Provider, { value: m, children: c });
};
export {
  F as ScaleProvider
};
